<template>
  <vx-card>
    <vs-row>
      <h4 class="mb-5">Add Sitemap</h4>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col vs-w="12" class="mb-3">
        <vs-input class="w-full" label="Name (*)" v-model="payload.name" />
        <span class="block text-sm mt-2 text-danger">{{
          errors.first("name")
        }}</span>
      </vs-col>
      <vs-col vs-w="12" class="mb-3">
        <vs-input class="w-full" label="URL (*)" v-model="payload.url" />
        <span class="block text-sm mt-2 text-danger">{{
          errors.first("url")
        }}</span>
      </vs-col>

      <vs-col vs-w="12" class="mt-3">
        <div class="vx-col w-full" @click.prevent="storeData">
          <vs-button class="mr-3 mb-2">Submit</vs-button>
        </div>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
// Store Module

import sitemapStore from "@/store/sitemap";
import vSelect from "vue-select";

export default {
  metaInfo: {
    title: "Add Sitemap",
    titleTemplate: "%s - Vancy Net",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  components: {
    vSelect,
  },

  data: () => ({
    payload: {
      name: "",
      url: "",
    },
  }),
  computed: {
    brands() {
      return this.$store.state.brandManagement.brands;
    },
  },

  methods: {
    async storeData() {
      const formData = new FormData();
      formData.set("name", this.payload.name);
      formData.set("url", this.payload.url);
      try {
        const response = await this.$store.dispatch(
          "sitemap/storeSitemap",
          formData
        );
        if (!response.success) {
          throw error(response.message);
        }
        this.$vs.notify({
          title: "Successful",
          text: response.msg_status,
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
        });

        this.$router.push("/sitemap");
      } catch (error) {
        console.log(error);
        this.$catchErrorResponse(error);
      }
    },
  },

  async created() {
    if (!sitemapStore.isRegistered) {
      this.$store.registerModule("sitemap", sitemapStore);
      sitemapStore.isRegistered = true;
    }
  },
};
</script>

<style></style>
